/**
 * @desc get route data
 * @param {*} data
 * @return {*}  {*}
 */
export const getRouteData = (data: any): any => {
  let step: string = data.inviteState ? data.inviteState.step : "";
  switch (step) {
    case "PRELIMINARY-STEP_ONE-BROKERS":
      return {
        view: "STEP_ONE",
        largeHeader: "Add a New Broker",
        largeSubHeader: "",
      };
    case "PRELIMINARY-STEP_TWO-BROKERS":
      return {
        view: "STEP_TWO",
        largeHeader: "",
        largeSubHeader: "",
      };
    default:
      break;
  }
};

/**
 * @desc get route
 * @param {*} data
 * @return {*}  {*}
 */
export const getRoute = (data: any): any => {
  let route: string = data.inviteState
    ? data.inviteState.step.split("-")[0]
    : "";
  switch (route) {
    case "PRELIMINARY":
      return "/brokers/add";
    case "FULL":
      return "/brokers/add/full";
    case "ALMOST_FULL":
      return "/broker/onboarding";
    case "COMPLETE":
      return "/dashboard";
    default:
      break;
  }
};
